export const cleanedAddresses = [
  ];

export const merkleRoot = "0x90486c2bd6763ef2ac9dbb56f6bac2d0e7245fc91ee82746bf290dc5d68ff536";

export const lastUpdatedTimestamp = new Date(1739293965202);
